<template>
	<Layout>
		<div class="l-container">
			<SectionTitle
				class="u-a11y-visually-hidden"
				:title="$I18n.trans('event_center.title')"
				type="main"
			/>
			<EventCenter
				:context-id="contextId"
				:context-type="contextType"
			/>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import SectionTitle from '@js/components/SectionTitle';
import EventCenter from '@js/components/EventCenter/EventCenter';

export default {
	name:       'ViewEventCenter',
	components: {
		EventCenter,
		Layout,
		SectionTitle,
	},
	props: {
		contextId: {
			type:     Number,
			required: true,
		},
		contextType: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style>

</style>
